<scf-calculator-header></scf-calculator-header>
<scf-point-of-sale
  [isMG]="false"
  [isMgWithShopping]="false"
  [isBP]="false"
  [operative]="operative"
  (changeContinueStatus)="changeContinueStatusForms($event)"
  (establishment)="updateCombos($event)"
  (vendor)="updateCombosVendor($event)"
  (isFinishedLoading)="changeContinueLoadingStatus($event)"
  (typeBalance)="updateBalance($event)"
>
</scf-point-of-sale>
<scf-financing-amount
  [typeBalance]="typeBalance"
  [establishment]="establishment"
  [maxAmount]="maxAmount"
  [isDisableCalculateButton]="disableSendClientButton"
  (changeContinueStatus)="changeContinueStatusForms($event)"
  (sendDataFinance)="openCalculateFinance($event)"
  (isFinishedLoading)="changeContinueLoadingStatus($event)"
  (sendOperative)="updateOperative($event)"
  (sendProductLine)="updateSelectedProductLine($event)"
  (sendPriceProduct)="updatePriceProduct($event)"
  (sendRequestedAmount)="updateRequestedAmount($event)"
  (sendStart)="updateStart($event)"
>
</scf-financing-amount>
<scf-request-data-uptake
  *ngIf="
    (typeBalance?.balance === 'S' && operative?.value !== null) || typeBalance?.balance !== 'S' || this.mode === 'view'
  "
  [establishment]="establishment"
  [vendor]="vendor"
  [isLoadingFinance]="isLoadingFinance"
  [expirationMonth]="expirationMonth"
  [operative]="operative"
  [isDisableSendClientButton]="disableSendClientButton"
  [selectedProductLine]="selectedProductLine"
  [requestedAmount]="requestedAmount"
  [priceProduct]="priceProduct"
  [start]="start"
  (maxAmount)="updateMaxAmount($event)"
  (changeContinueStatus)="changeContinueStatusForms($event)"
  (sendDataFinance)="openCalculateFinance($event)"
  (isFinishedLoading)="changeContinueLoadingStatus($event)"
>
</scf-request-data-uptake>
<scf-request-finance
  *ngIf="
    ((typeBalance?.balance === 'S' && operative?.value !== null) || typeBalance?.balance !== 'S') && mode !== 'view'
  "
  [establishment]="establishment"
  [operative]="operative?.value"
  [dataCallSimulation]="dataFinance"
  [isCalculator]="true"
  (switchScreen)="switchScreenAlta($event)"
  [changing]="changingValueClearTable"
  (changeContinueStatus)="changeContinueStatusForms($event)"
  (loading)="isLoadingFinance = $event"
  (isFinishedLoading)="changeContinueLoadingStatus($event)"
  (changeExpiredMonth)="getExpiredMonth($event)"
>
</scf-request-finance>
